module.exports = __webpack_public_path__ + "4954c95f97a5634c0c4f877f7c5c8452.pdf";